(function(){
  var box=document.getElementById("fitbox"); if(!box) return;
  var mk=document.getElementById("fmk"), md=document.getElementById("fmd"), yr=document.getElementById("fyr"),
      go=document.getElementById("fgo"), res=document.getElementById("fitres");
  var SKU=box.dataset.sku, DATA=null, MAKES={};
  function fill(sel,items,ph){
    sel.innerHTML='<option value="">'+ph+'</option>'+items.map(function(v){return '<option value="'+v+'">'+v+'</option>'}).join("");
    sel.disabled=!items.length;
  }
  fetch(box.dataset.racks).then(function(r){return r.json()}).then(function(j){
    DATA=j;
    j.forEach(function(p){ p.fits.forEach(function(f){ (MAKES[f[0]]=MAKES[f[0]]||{})[f[1]]=1 }) });
    fill(mk,Object.keys(MAKES).sort(),"Select make");
  }).catch(function(){ box.hidden=true });
  mk.addEventListener("change",function(){
    fill(md,mk.value?Object.keys(MAKES[mk.value]).sort():[],"Select model");
    fill(yr,[],"Year"); res.hidden=true;
  });
  md.addEventListener("change",function(){
    var years={};
    if(mk.value&&md.value) DATA.forEach(function(p){ p.fits.forEach(function(f){
      if(f[0]===mk.value&&f[1]===md.value) for(var y=f[2];y<=f[3];y++) years[y]=1; }) });
    fill(yr,Object.keys(years).sort().reverse(),"Year"); res.hidden=true;
  });
  go.addEventListener("click",function(){
    if(!DATA||!mk.value||!md.value){ show("no","Pick a make and a model first."); return; }
    var y=yr.value?parseInt(yr.value,10):null;
    var match=function(p){ return p.fits.some(function(f){
      return f[0]===mk.value&&f[1]===md.value&&(!y||(y>=f[2]&&y<=f[3])); }) };
    var mine=DATA.filter(function(p){ return p.sku===SKU });
    var v=mk.value+" "+md.value+(y?" "+y:"");
    if(mine.length&&match(mine[0])){ show("yes","<b>Yes. "+SKU+" fits your "+v+".</b> Add it to your order below."); return; }
    var others=DATA.filter(match).map(function(p){ return p });
    if(!others.length){ show("no","<b>"+SKU+" does not fit your "+v+"</b>, and we have no rack listed for it yet. Call (787) 510-8075 and we check the factory."); return; }
    var list=others.slice(0,3).map(function(p){ return '<a href="/products/'+p.h+'">'+p.sku+"</a>" }).join(", ");
    show("no","<b>"+SKU+" does not fit your "+v+".</b> For that vehicle you need "+list+(others.length>3?" and "+(others.length-3)+" more":"")+".");
  });
  function show(kind,html){ res.className="fitres "+kind; res.innerHTML=html; res.hidden=false; }
})();
